import { defineStore } from 'pinia'

export const useSsInfoStore = defineStore('ssInfoStore', {
  state: () => ({
    ssInfo: null
  })
})
